import {pageInfo, detail, rePush} from './../api';
import {Message} from 'element-ui';

const waybill = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    detailObj: null,
    rePushObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [true, item.dealStatus == '处理失败'] }));
    },
    DETAIL(state, data) {
      state.detailObj = data.obj;
    },
    RE_PUSH(state, data) {
      state.rePushObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async detail({commit}, obj) {
      let resp = await detail(obj);
      commit('DETAIL', resp);
    },
    async rePush({commit}, obj) {
      let resp = await rePush(obj);
      commit('RE_PUSH', resp);
    },
  }
}
export default waybill



// WEBPACK FOOTER //
// ./src/page/log/waybill/store/waybill.store.js